export const SPORT_ICON_CLASS = {
    "american-football": "fas fa-football-ball", // or "fas fa-football" in FA6
    baseball: "fas fa-baseball-ball",            // or "fas fa-baseball" in FA6
    basketball: "fas fa-basketball-ball",        // or "fas fa-basketball" in FA6
    hockey: "fas fa-hockey-puck",
    rugby: "fas fa-football-ball",               // closest match; FA doesn't always have rugby in older packs
    soccer: "fas fa-futbol",
    softball: "fas fa-baseball-ball",            // closest match
    volleyball: "fas fa-volleyball-ball",        // or "fas fa-volleyball" in FA6
};

export const SportIcon = ({ sportKey, className = "" }) => (
    <i className={`${SPORT_ICON_CLASS[sportKey] ?? "fas fa-futbol"} ${className}`} />
);